function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
import { middlewareHelper } from "./middleware.js";
import { mix } from "./utils.js";
import { FETCH_ERROR, CATCHER_FALLBACK } from "./constants.js";
/**
 * This class inheriting from Error is thrown when the fetch response is not "ok".
 * It extends Error and adds status, text and body fields.
 */
export var WretchError = /*#__PURE__*/function (_Error) {
  _inherits(WretchError, _Error);
  var _super = _createSuper(WretchError);
  function WretchError() {
    _classCallCheck(this, WretchError);
    return _super.apply(this, arguments);
  }
  return _createClass(WretchError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var resolver = function resolver(wretch) {
  var sharedState = Object.create(null);
  wretch = wretch._addons.reduce(function (w, addon) {
    return addon.beforeRequest && addon.beforeRequest(w, wretch._options, sharedState) || w;
  }, wretch);
  var _wretch = wretch,
    url = _wretch._url,
    opts = _wretch._options,
    config = _wretch._config,
    _catchers = _wretch._catchers,
    resolvers = _wretch._resolvers,
    middlewares = _wretch._middlewares,
    addons = _wretch._addons;
  var catchers = new Map(_catchers);
  var finalOptions = mix(config.options, opts);
  // The generated fetch request
  var finalUrl = url;
  var _fetchReq = middlewareHelper(middlewares)(function (url, options) {
    finalUrl = url;
    return config.polyfill("fetch")(url, options);
  })(url, finalOptions);
  // Throws on an http error
  var referenceError = new Error();
  var throwingPromise = _fetchReq["catch"](function (error) {
    throw _defineProperty({}, FETCH_ERROR, error);
  }).then(function (response) {
    if (!response.ok) {
      var err = new WretchError();
      // Enhance the error object
      err["cause"] = referenceError;
      err.stack = err.stack + "\nCAUSE: " + referenceError.stack;
      err.response = response;
      err.url = finalUrl;
      if (response.type === "opaque") {
        throw err;
      }
      return response.text().then(function (body) {
        var _a;
        err.message = body;
        if (config.errorType === "json" || ((_a = response.headers.get("Content-Type")) === null || _a === void 0 ? void 0 : _a.split(";")[0]) === "application/json") {
          try {
            err.json = JSON.parse(body);
          } catch (e) {/* ignore */}
        }
        err.text = body;
        err["status"] = response.status;
        throw err;
      });
    }
    return response;
  });
  // Wraps the Promise in order to dispatch the error to a matching catcher
  var catchersWrapper = function catchersWrapper(promise) {
    return promise["catch"](function (err) {
      var fetchErrorFlag = err.hasOwnProperty(FETCH_ERROR);
      var error = fetchErrorFlag ? err[FETCH_ERROR] : err;
      var catcher = (error === null || error === void 0 ? void 0 : error.status) && catchers.get(error.status) || catchers.get(error === null || error === void 0 ? void 0 : error.name) || fetchErrorFlag && catchers.has(FETCH_ERROR) && catchers.get(FETCH_ERROR);
      if (catcher) return catcher(error, wretch);
      var catcherFallback = catchers.get(CATCHER_FALLBACK);
      if (catcherFallback) return catcherFallback(error, wretch);
      throw error;
    });
  };
  var bodyParser = function bodyParser(funName) {
    return function (cb) {
      return funName ?
      // If a callback is provided, then callback with the body result otherwise return the parsed body itself.
      catchersWrapper(throwingPromise.then(function (_) {
        return _ && _[funName]();
      }).then(function (_) {
        return cb ? cb(_) : _;
      })) :
      // No body parsing method - return the response
      catchersWrapper(throwingPromise.then(function (_) {
        return cb ? cb(_) : _;
      }));
    };
  };
  var responseChain = {
    _wretchReq: wretch,
    _fetchReq: _fetchReq,
    _sharedState: sharedState,
    res: bodyParser(null),
    json: bodyParser("json"),
    blob: bodyParser("blob"),
    formData: bodyParser("formData"),
    arrayBuffer: bodyParser("arrayBuffer"),
    text: bodyParser("text"),
    error: function error(errorId, cb) {
      catchers.set(errorId, cb);
      return this;
    },
    badRequest: function badRequest(cb) {
      return this.error(400, cb);
    },
    unauthorized: function unauthorized(cb) {
      return this.error(401, cb);
    },
    forbidden: function forbidden(cb) {
      return this.error(403, cb);
    },
    notFound: function notFound(cb) {
      return this.error(404, cb);
    },
    timeout: function timeout(cb) {
      return this.error(408, cb);
    },
    internalError: function internalError(cb) {
      return this.error(500, cb);
    },
    fetchError: function fetchError(cb) {
      return this.error(FETCH_ERROR, cb);
    }
  };
  var enhancedResponseChain = addons.reduce(function (chain, addon) {
    return _objectSpread(_objectSpread({}, chain), addon.resolver);
  }, responseChain);
  return resolvers.reduce(function (chain, r) {
    return r(chain, wretch);
  }, enhancedResponseChain);
};